import { Spinner } from 'office-ui-fabric-react';
import * as React from 'react';

import { DiagnosticsActionStatus } from '../../models';
import { createStructuredSelector, mconnect } from '../../state/redux';
import { IStyledComponent, styledComponent } from '../../theme';
import { IComponentStateProps, IConnectedComponentProps, ISafActionNodeStyles } from '../../types';
import { getSafActionNodeClassNames, getSafActionNodeStyles } from '../intentGraph.styles';
import { dispatchStartSAFDiagnosticsAction } from '../reducers/dispatchers';
import {
  diagnosticsFormSelector,
  enableUsingCallBacksForSAFApisSelector,
  getNodeSelector,
  globalVarsSelector,
  isDiagnosticActionInProgressSelector,
  jsonPayloadMetaSelector,
  sessionIdSelector
} from '../reducers/selectors.redux';
import { SafInlineDiagnostics } from './safInlineDiagnostics';
import { resetSafDiagnosticAction } from '../reducers/actions';

import { DiagnosticStatusBar } from './diagnosticStatusBar';

const mapStateToProps = createStructuredSelector({
  node: getNodeSelector,
  sessionId: sessionIdSelector,
  meta: jsonPayloadMetaSelector,
  diagnosticsForm: diagnosticsFormSelector,
  isDiagnosticsInProgress: isDiagnosticActionInProgressSelector,
  enableUsingCallBacksForSAFApis: enableUsingCallBacksForSAFApisSelector,
  globalVars: globalVarsSelector
});

const mapDispatchToProps = { dispatchStartSAFDiagnosticsAction, resetSafDiagnosticAction };
const uuidv4 = require('uuid/v4');

type ISafActionNodeProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  IStyledComponent<ISafActionNodeStyles> &
  IConnectedComponentProps &
  IComponentStateProps;

class SafActionNodeC extends React.PureComponent<ISafActionNodeProps> {
  constructor(props: ISafActionNodeProps) {
    super(props);
  }

  public componentDidMount(): void {
    if (
      !!this.props.callbackHandlers.GetSAFActionSchema &&
      typeof this.props.callbackHandlers.GetSAFActionSchema === 'function'
    ) {
      this.props.resetSafDiagnosticAction();
      this.props.dispatchStartSAFDiagnosticsAction(
        this.props.node,
        this.props.callbackHandlers.GetSAFActionSchema,
        this.props.callbackHandlers.LogHandler,
        this.props.enableUsingCallBacksForSAFApis
      );
    }
  }

  public render = (): React.ReactNode => {
    const classNames = getSafActionNodeClassNames(this.props.styles, {
      theme: this.props.theme,
      stylesFunc: this.props.stylesFunc
    });
    const status = this.props.node.get('diagnosticsActionStatus');
    const showSafStatusBar =
      status === DiagnosticsActionStatus.CompletedSuccessfully || status === DiagnosticsActionStatus.Error;
    return (
      <div className={classNames.safContainer}>
        {showSafStatusBar && 
          <DiagnosticStatusBar 
            classNames={classNames} 
            node={this.props.node} 
            prefix={'saf'} 
            callbackHandlers={this.props.callbackHandlers}
            stylesFunc={this.props.stylesFunc}
            sessionId={this.props.sessionId}
            meta={this.props.meta}
            theme={this.props.theme}
            globalVars={this.props.globalVars}
            dialogId={this.props.dialogId}
          />
        }
        {!showSafStatusBar && this._getDiagnosticForm()}
        {this._showProgressSpinner() && <Spinner styles={getSafActionNodeStyles(this.props).spinner} />}
      </div>
    );
  };

  private _getDiagnosticForm = () => {
    return (
      this.props.diagnosticsForm.size > 0 && (
        <SafInlineDiagnostics
          stylesFunc={this.props.stylesFunc}
          isSAFAction={true}
          callbackHandlers={this.props.callbackHandlers}
          nodeId={this.props.nodeId}
          uId={this.props.uId}
          dialogId={this.props.dialogId}
        />
      )
    );
  };

  private _showProgressSpinner = () => {
    return (
      this.props.node.get('diagnosticsActionStatus') === undefined ||
      this.props.node.get('diagnosticsActionStatus') === DiagnosticsActionStatus.FetchingDiagnosticsInProgress
    );
  };
}

export const SafActionNode = mconnect(
  mapStateToProps,
  mapDispatchToProps
)(styledComponent(SafActionNodeC, getSafActionNodeStyles));
